import { Injectable } from "@angular/core";
import { AlulaDevice } from "@app/project/model/alula-device";
import { AlulaSelectors } from "@app/project/store";
import { AlulaActions } from "@app/project/store/actions";
import { RootStoreState } from "@app/root-store";
import { Action, select, Store } from "@ngrx/store";

@Injectable({
    providedIn: "root",
})
export class AlulaDispatchers {
    clearAlulaState() {
        this.store.dispatch(new AlulaActions.ClearAlulaState());
    }

    updateAlulaDevice(alulaDevice: AlulaDevice) {
        this.store.dispatch(new AlulaActions.UpdateAlulaDevice(alulaDevice));
    }

    selectAlulaDevice$() {
        return this.store.pipe(select(AlulaSelectors.getAlulaDevice));
    }

    selectAlulaUser$() {
        return this.store.pipe(select(AlulaSelectors.getAlulaUser));
    }

    selectIsLoadingSecurityMonitoring$() {
        return this.store.pipe(select(AlulaSelectors.isLoadingSecurityMonitoring));
    }

    dispatchAction(action: Action) {
        this.store.dispatch(action);
    }

    constructor(private readonly store: Store<RootStoreState.State>) {}
}
